export const defaultPageSizeOptions = [25, 50, 100, 200];
export const defaultPageSize = defaultPageSizeOptions[0];
